/**
 * Helpers and wrappers for immutable js functions.
 */

import Immutable, { fromJS } from 'immutable';

/**
 * A quick and dirty deep clone function.  Presumably this is expensive, and
 * should be avoided if possible
 */
const deepCloneBasicObj = (obj) => (JSON.parse(JSON.stringify(obj)));

/**
 * Returns true if an object is an immutablejs collection, otherwise it returns
 * false.  IMO this is more readable than `Immutable.Iterable.isIterable`
 * @param  {Object}  object The deeply nested object to test
 * @return {Boolean} True if object is an immutablejs type.  Else false.
 */
export const isImmutable = (object) => (Immutable.Iterable.isIterable(object));

/**
 * Attempts to convert an object or array to immutable js types.
 * fromJS fails if the object was created in another iframe. This is unfortunate
 * since often our objects are created in an iframe.  This method performs a
 * deep copy if it fails to convert an object with fromJS.
 * @param  {Object} object Deeply nested object or array
 * @return {Immutablejs Map | Immutablejs List} the converted Immutablejs
 * collection
 */
export const toImmutable = (object) => {
  // Object is an immutable, that's good.  Just return.
  if (isImmutable(object)) {
    return object;
  }

  let newObj = fromJS(object);

  // Successfully converted object to an immutable.  return
  // conveted immutable.
  if (isImmutable(newObj)) {
    return newObj;
  }

  // Failed to convert object to immutable!  This is probably because
  // the object was constructed in an iframe (see: https://goo.gl/EhwYA5). We
  // now clone the object and try again.
  newObj = fromJS(deepCloneBasicObj(object));
  if (isImmutable(newObj)) {
    return newObj;
  }

  throw new Error('could not convert to immutablejs');
};
